import { uniqBy } from 'lodash';
import { AnalyticsTypes } from '../../../../../middleware/google-analytics';
import { updateBookingState } from '../../../../actions/SchedulingActions/AsynchronousSchedulingActions';
import { APPOINTMENT_DETAILS_GA_CATEGORY } from '../../../../pages/AppointmentDetails/constants';
import bookingStateSelector from '../../../../selectors/BookingStateSelector';
import {
    ACTION_PREFIX,
    GaActionText,
    USING_INSURANCE_WARNING,
} from '../../constants';
import { getRequirement } from '../../helpers';

export const CLICK_USING_INSURANCE_CHECKBOX = `${ACTION_PREFIX}/CLICK_USING_INSURANCE_CHECKBOX`;

export const TRACK_CLICK_USING_INSURANCE_CHECKBOX = `${ACTION_PREFIX}/TRACK_CLICK_USING_INSURANCE_CHECKBOX`;

function updateRequirementInBookingState(
    usingInsuranceConfirmation,
    bookingState
) {
    let requirements = (bookingState && bookingState.requirements) || [];
    const requirement = getRequirement(USING_INSURANCE_WARNING, requirements);
    requirement.value = usingInsuranceConfirmation;
    requirements.push(requirement);
    requirements = uniqBy(requirements, (r) => r.key);
    bookingState.requirements = requirements;
    return bookingState;
}

export function clickCheckbox(usingInsuranceConfirmation) {
    return (dispatch, getState) => {
        dispatch({
            type: CLICK_USING_INSURANCE_CHECKBOX,
            payload: {
                usingInsuranceConfirmation,
            },
        });

        const state = getState();
        const bookingState = bookingStateSelector(state);
        const requestBody = updateRequirementInBookingState(
            usingInsuranceConfirmation,
            bookingState
        );
        dispatch(updateBookingState(requestBody));
    };
}

export const trackClickUsingInsuranceWarning = () => ({
    type: TRACK_CLICK_USING_INSURANCE_CHECKBOX,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_DETAILS_GA_CATEGORY,
            action: GaActionText.trackClickUsingInsuranceWarning,
        },
    },
});
